import { BookDatabase16Regular } from '@fluentui/react-icons';

import { iconMap } from '@modules/items';

import { EAiCitationSourceType } from '../../types';

const SOURCE_ICON_SIZE_PX = 16;

type TProps = {
  sourceType: EAiCitationSourceType;
};

const SourceIcon = ({ sourceType }: TProps) => {
  if (sourceType === EAiCitationSourceType.LITERATURE) {
    return <BookDatabase16Regular aria-hidden />;
  }
  const ICON_SRC: Record<EAiCitationSourceType.DOCUMENT | EAiCitationSourceType.FILE, string> = {
    [EAiCitationSourceType.DOCUMENT]: iconMap.docx,
    [EAiCitationSourceType.FILE]: iconMap.pdf,
  };
  return <img src={ICON_SRC[sourceType]} alt="" style={{ width: SOURCE_ICON_SIZE_PX, height: SOURCE_ICON_SIZE_PX }} />;
};

export default SourceIcon;
